import { Routes, Route, Navigate } from "react-router-dom";

import TiendaLayout from "../layout/TiendaLayout";
import Login from "../pages/usuarios_tienda/TiendaLogin";
import AdminHome from "../pages/usuarios_tienda/TiendaHome";
import UsersPage from "../pages/usuarios_tienda/usuarios/UsersPage";
import RolesPage from "../pages/usuarios_tienda/roles/RolesPage";
import PermisosPage from "../pages/usuarios_tienda/permisos/PermisosPage";
import CategoryFormModal from "../pages/usuarios_tienda/Categorias/CategoriesPage";
import ShippingFormModal from "../pages/usuarios_tienda/metodos_envio/ShippingMethodsPage";
import BrandsPage from "../pages/usuarios_tienda/marcas/BrandsPage";
import CustomersPage from "../pages/usuarios_tienda/clientes/CustomersPage";
import CustomerAddressesPage from "../pages/usuarios_tienda/clientes/CustomerAddressesPage";
import ProductsPage from "../pages/usuarios_tienda/productos/ProductsPage";
import ProductFormPage from "../pages/usuarios_tienda/productos/ProductFormPage";
import OrdersPage from "../pages/usuarios_tienda/pedidos/OrdersPage";
import CreateOrderPage from "../pages/usuarios_tienda/pedidos/CreateOrderPage";
import TiendaDashboardPage from "../pages/usuarios_tienda/dashboard/TiendaDashboardPage";
import ShippingZonesPage from "../pages/usuarios_tienda/zona_envios/ShippingZonesPage";
import ProtectedRoute from "./ProtectedRoute";
import RequirePerm from "./RequirePerm";
import PaymentMethodsPage from "../pages/usuarios_tienda/metodos_pago/PaymentMethodsPage";
import TiendaSetupPage from "../pages/usuarios_tienda/tienda/TiendaSetupPage";
import UserProfilePage from "../pages/usuarios_tienda/perfil/UserProfilePage";
import AcceptInvitationPage from "../pages/usuarios_tienda/invitacion/AcceptInvitationPage";
import ResetPasswordPage from "../pages/usuarios_tienda/password/ResetPasswordPage";
import ForgotPasswordPage from "../pages/usuarios_tienda/password/ForgotPasswordPage";
import DesignEditorPage from "../pages/usuarios_tienda/tienda/DesignEditorPage";

function TiendaRoutes() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="aceptar-invitacion" element={<AcceptInvitationPage />} />
      <Route path="restablecer-contrasena" element={<ResetPasswordPage />} />
      <Route path="recuperar-contrasena" element={<ForgotPasswordPage />} />

      <Route element={<ProtectedRoute />}>
        {/* Editor de diseño a pantalla completa (sin el layout admin) */}
        <Route element={<RequirePerm perm="view_shipping_zones" />}>
          <Route path="diseno" element={<DesignEditorPage />} />
        </Route>

        <Route element={<TiendaLayout />}>
          <Route index element={<AdminHome />} />

          <Route path="perfil" element={<UserProfilePage />} />

          <Route element={<RequirePerm perm="view_user" />}>
            <Route path="config/users" element={<UsersPage />} />
          </Route>

          <Route element={<RequirePerm perm="view_rol" />}>
            <Route path="config/roles" element={<RolesPage />} />
          </Route>

          <Route element={<RequirePerm perm="View_permissions" />}>
            <Route path="config/permissions" element={<PermisosPage />} />
          </Route>

          <Route element={<RequirePerm perm="view_categories" />}>
            <Route path="categories" element={<CategoryFormModal />} />
          </Route>

          <Route element={<RequirePerm perm="view_shipping_methods" />}>
            <Route path="shipping-methods" element={<ShippingFormModal />} />
          </Route>

          <Route element={<RequirePerm perm="view_shipping_zones" />}>
            <Route path="zona-envios" element={<ShippingZonesPage />} />
          </Route>

          <Route element={<RequirePerm perm="view_brand" />}>
            <Route path="brands" element={<BrandsPage />} />
          </Route>

          <Route element={<RequirePerm perm="view_customer" />}>
            <Route path="customers" element={<CustomersPage />} />
          </Route>

          <Route element={<RequirePerm perm="update_direccion_customer" />}>
            <Route
              path="customers/:clienteId/addresses"
              element={<CustomerAddressesPage />}
            />
          </Route>

          <Route element={<RequirePerm perm="view_product" />}>
            <Route path="products" element={<ProductsPage />} />
          </Route>

          <Route element={<RequirePerm perm="create_product" />}>
            <Route path="products/nuevo" element={<ProductFormPage />} />
          </Route>

          <Route element={<RequirePerm perm="update_product" />}>
            <Route path="products/:productoId/editar" element={<ProductFormPage />} />
          </Route>

          <Route element={<RequirePerm perm="view_orders" />}>
            <Route path="dashboard" element={<TiendaDashboardPage />} />
            <Route path="orders" element={<OrdersPage />} />
          </Route>

          <Route element={<RequirePerm anyOf={["create_orders", "move_orders"]} />}>
            <Route path="orders/nuevo" element={<CreateOrderPage />} />
          </Route>

          <Route
            path="config/subcategorias"
            element={<Navigate to="/administracion/tienda/categories" replace />}
          />
          <Route element={<RequirePerm perm="view_payment_methods" />}>
            <Route path="payment-methods" element={<PaymentMethodsPage />} />

          </Route>

          <Route element={<RequirePerm perm="view_shipping_zones" />}>
            <Route path="tienda" element={<TiendaSetupPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default TiendaRoutes;